import { useNavigate } from 'react-router-dom'
import { IOpsTodayQuestionCard } from 'types/opsToday.interface'
import {
  AnswerCaption,
  AnswerSentence,
  QuestionCardWrap,
  QuestionLabel,
  TrendChip,
  TrendNote,
  TrendRow,
  ViewLink,
} from './OpsToday.styled'

export const TodayQuestionCard = ({ card }: { card: IOpsTodayQuestionCard }) => {
  const navigate = useNavigate()
  return (
    <QuestionCardWrap $tone={card.tone}>
      <QuestionLabel>{card.question}</QuestionLabel>
      <AnswerSentence $tone={card.tone}>{card.sentence}</AnswerSentence>
      <AnswerCaption>{card.caption}</AnswerCaption>
      {card.trend && (
        <TrendRow>
          {card.trend.chips.map((chip, index) => (
            <TrendChip key={`${card.id}-${index}`}>{chip}</TrendChip>
          ))}
          <TrendNote>{card.trend.note}</TrendNote>
        </TrendRow>
      )}
      <ViewLink onClick={() => navigate(card.linkPath)}>View →</ViewLink>
    </QuestionCardWrap>
  )
}
